// Session calendars use IANA timezones, so DST is resolved for each candle.
export function vwapAnchor(time,anchor,timezone='UTC',sessionStart='00:00') {
    let local=time;
    if(timezone!=='UTC'){
        const parts=new Intl.DateTimeFormat('en-CA',{timeZone:timezone,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).formatToParts(time);
        const get=key=>Number(parts.find(part=>part.type===key).value);
        local=Date.UTC(get('year'),get('month')-1,get('day'),get('hour'),get('minute'));
    }
    const date=new Date(local),year=date.getUTCFullYear(),month=date.getUTCMonth();
    if(anchor==='Week')return Math.floor((local+259200000)/604800000);
    if(anchor==='Month')return year*12+month;
    if(anchor==='Quarter')return year*4+Math.floor(month/3);
    if(anchor==='Year')return year;
    if(anchor==='Decade')return Math.floor(year/10);
    if(anchor==='Century')return Math.floor(year/100);
    const match=/^(\d{2}):(\d{2})$/.exec(sessionStart);
    const offset=anchor==='Session'&&match?(Number(match[1])*60+Number(match[2]))*60000:0;
    return Math.floor((local-offset)/86400000);
}
